import { sealingService } from '@paragon/data-connections';
import { enqueueInfo, enqueueWarning } from '@paragon/notification-tools';
import { addSpinnerMessage, removeSpinnerMessage } from '@paragon/task-spinner';

import { addSeal } from '../store/seals';
import { AsyncThunkActionVoid } from './thunkActions';

export function loadSeals(): AsyncThunkActionVoid {
  return (dispatch, getState) => {
    const state = getState();
    const spinnerId = dispatch(addSpinnerMessage('Loading seal...'));

    return sealingService.seals
      .fetch(state.logInData.loggedInUser!.email)
      .then((loadedSeals) => {
        const applicableSeals = loadedSeals.filter((el) => state.job.regions.includes(el.region));
        const unregisteredRegions = state.job.regions.filter(
          (el) => applicableSeals.filter((elem) => elem.region === el).length === 0,
        );

        for (const unregisteredRegion of unregisteredRegions) {
          dispatch(enqueueWarning(`This user is not registered for ${unregisteredRegion}`));
          dispatch(enqueueInfo('Visit accounts.paragontruss.com to manage your seals.'));
        }
        for (const loadedSeal of applicableSeals) {
          const expirationDate = new Date(loadedSeal.renewalDate);
          if (expirationDate < new Date()) {
            dispatch(enqueueWarning(`Your seal for ${loadedSeal.region} expired on ${expirationDate.toDateString()}.`));
            dispatch(enqueueInfo('Visit accounts.paragontruss.com to manage your seals.'));
          }

          dispatch(addSeal({ loadedSeal }));
        }
        dispatch(removeSpinnerMessage(spinnerId));
      })
      .catch(() => {
        dispatch(enqueueWarning('This user is not registered for any regions.'));
        dispatch(enqueueInfo('Visit accounts.paragontruss.com to manage your seals.'));
        dispatch(removeSpinnerMessage(spinnerId));
      });
  };
}
